// A public guide token grants access. Redact it at the final SDK boundaries,
// including nested referrers, navigation breadcrumbs and rrweb metadata.
const separator = String.raw`(?:/|%2f|%252f)`;
const capabilityPath = new RegExp(
  `(${separator}study-guide(?:s${separator}shared)?${separator})(?:(?!%3f|%23|%253f|%2523)[a-z0-9_.%~-])+`,
  "gi"
);

// A landing-page handoff carries an anonymous upload's private claim in its
// fragment (`#uploadClaim=`); it lets the holder generate from that upload.
const uploadClaimFragmentParameter = /(uploadClaim(?:=|%3d|%253d))[a-f0-9]{64}/gi;

export function redactStudyGuideCapabilityUrl(value: string): string {
  return value.replace(capabilityPath, "$1redacted").replace(uploadClaimFragmentParameter, "$1redacted");
}

/** Copy JSON-shaped SDK data; preserve unrelated URLs and non-JSON objects. */
export function redactStudyGuideTelemetryUrls<T>(value: T): T {
  const seen = new WeakMap<object, unknown>();
  const redact = (entry: unknown): unknown => {
    if (typeof entry === "string") return redactStudyGuideCapabilityUrl(entry);
    if (!entry || typeof entry !== "object") return entry;
    if (!Array.isArray(entry) && Object.getPrototypeOf(entry) !== Object.prototype) return entry;
    if (seen.has(entry)) return seen.get(entry);
    const result = Array.isArray(entry) ? [] : {};
    seen.set(entry, result);
    for (const [key, nested] of Object.entries(entry)) result[key] = redact(nested);
    return result;
  };
  return redact(value) as T;
}
